<template>
  <div>
    <router-view />
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>
<script>
import { getStorageData } from "@/utils/storage";

export default {
  mounted() {
    if (this.$hj) {
      const user = getStorageData("user");
      const identify = {
        id: user.uuid,
        email: user.email,
        fullName: user.fullName
      };

      this.$hj('identify', identify.id, identify);
    }
  },
};
</script>
<style></style>
